<template>
    <div>
        <!-- 所有组件自动添加入场动画 -->
        <NavWrap />
        <router-view />
        <Footer />
    </div>
</template>

<script>
import NavWrap from "../../components/NavWrap"
import Footer from "../../components/Footer"

export default {
    components: {
        NavWrap,
        Footer
    }
    
}
</script>

<style>

</style>